const Distributors = () => import("Core/companies/distributors/views/Distributors");
const DistributorsForm = () => import("Core/companies/distributors/views/DistributorsForm");
const DistributorProfile = () => import("Core/companies/distributors/views/DistributorProfile");

export default {
    children: [
        {
            path: "configuration/distributors",
            name: "distributors",
            component: Distributors,
            meta: {
                requiresAuth: true,
                title: "lang.distributors",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/distributor/:id?",
            name: "distributor",
            component: DistributorProfile,
            meta: {
                requiresAuth: true,
                title: "lang.distributors",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
